export const SECRET_AUCTION_CREATE_PAGE_PATH = '/auction/secret/create'
